import Vue from 'b2b-common/vue-config'
import GetTextPlugin from 'vue-gettext'
import { translateConfig } from './translate'

Vue.use(GetTextPlugin, translateConfig)

export const $gettextInterpolate = Vue.prototype.$gettextInterpolate
export const $gettext = Vue.prototype.$gettext
